import { NgModule, ModuleWithProviders } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@angular/material';
import { ATLASENSE_PROVIDERS } from '../services';
import { LoginComponent } from './login.component';

@NgModule({
  imports: [CommonModule, MaterialModule, FormsModule],
  exports: [LoginComponent],
  declarations: [LoginComponent],
})
export class LoginModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: LoginModule,
      providers: [ATLASENSE_PROVIDERS],
    };
  }
}
